import { render } from "./change-pwd.vue?vue&type=template&id=66834b50&scoped=true&ts=true"
import script from "./change-pwd.vue?vue&type=script&lang=ts"
export * from "./change-pwd.vue?vue&type=script&lang=ts"

import "./change-pwd.vue?vue&type=style&index=0&id=66834b50&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66834b50"]])

export default __exports__